export enum QuestionOrder {
  Sequential = "sequential",
  Intelligent = "intelligent",
}
